import { createElementVNode as _createElementVNode, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aa86f9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "r-check" }
const _hoisted_2 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "10",
  cy: "10",
  r: "9.5",
  stroke: "#2F98EE"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "10",
  cy: "10",
  r: "5",
  fill: "#2F98EE"
}, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "10",
  cy: "10",
  r: "9.5",
  stroke: "black",
  "stroke-opacity": "0.3"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "rbox",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handclick()))
    }, [
      _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5, 512)), [
        [_vShow, _ctx.modelValue==_ctx.index]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8, 512)), [
        [_vShow, _ctx.modelValue!=_ctx.index]
      ])
    ]),
    _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
  ]))
}